import React from 'react';
import PropTypes from 'prop-types';
import { InsertDriveFile, Close } from '@mui/icons-material';
import { Divider, IconButton } from '@mui/material';

const Documents = ({ documents, onDelete }) => {
    return documents.map((doc, index) => {
        return (
            <Document
                doc={doc}
                onDelete={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDelete(doc, index);
                }}
                key={`${doc.fileType}-${index}`}
            />
        );
    });
};

export const Document = ({ doc, onDelete }) => {
    const href = doc.url || (doc.file instanceof File ? URL.createObjectURL(doc.file) : undefined);
    const displayName = doc.fileType || (doc.file instanceof File ? doc.file.name : 'Unknown file');

    return (
        <a
            href={href}
            target='_blank'
            className='tw-flex tw-items-center tw-font-[500] tw-bg-[#0091EA29] tw-rounded-[8px] tw-gap-[12px] tw-p-[16px]'
            title={displayName}
        >
            <div className='tw-w-[16px]'>
                <InsertDriveFile size={24} />
            </div>
            <div className='tw-truncate tw-grow tw-capitalize'>{doc.fileType ? doc.fileType : doc.file.name}</div>
            <Divider orientation='vertical' flexItem />
            <IconButton onClick={onDelete}>
                <Close />
            </IconButton>
        </a>
    );
};

const Doc = PropTypes.shape({
    url: PropTypes.string,
    file: PropTypes.instanceOf(File),
    fileType: PropTypes.string
});

Document.propTypes = {
    doc: Doc,
    onDelete: PropTypes.func.isRequired
};

Documents.propTypes = {
    documents: PropTypes.arrayOf(Doc).isRequired,
    onDelete: PropTypes.func.isRequired
};

export default Documents;
